var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRedo01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3746_22232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.541 6.83944C12.9967 3.92215 10.4373 1.71387 7.36215 1.71387C3.89066 1.71387 1.07649 4.52807 1.07649 7.99958C1.07649 11.4711 3.89066 14.2853 7.36215 14.2853C10.0273 14.2853 12.305 12.6267 13.2194 10.2853",
    stroke: "#6C757D",
    strokeWidth: 1.71333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3857 5.55368C10.5599 6.67226 11.9466 7.09746 13.546 6.82928C14.6646 5.65511 15.0898 4.26833 14.8216 2.66895",
    stroke: "#6C757D",
    strokeWidth: 1.71333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3746_22232"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(-1 0 0 1 16 0)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo01);
export default __webpack_public_path__ + "static/media/redo-01.435f43b94490fbf21d8e7a9fd16149aa.svg";
export { ForwardRef as ReactComponent };